import { StyleSheet } from 'aphrodite';
import { darkGrayFontColor, titles } from '../../../styles/colors';
import { Layouts } from '../../../styles/styles';

export const styleSheet = StyleSheet.create({
	onboardingCheckboxLabel: {
		display: 'flex',
		alignItems: 'center',
		gap: 8,
		fontSize: 12,
		color: darkGrayFontColor,
	},
	columns: {
		display: 'flex',
		justifyContent: 'space-between',
	},
	container: {
		...Layouts.verticalStack(40),
	},
	radioOption: {
		color: '#858585',
		fontSize: 14,
		display: 'block',
	},
	section: {
		...Layouts.verticalStack(15),
	},
	sectionHeader: {
		color: titles,
		fontSize: 18,
	},
	sectionHeaderIcon: {
		height: 20,
		width: 'auto',
	},
});
